export const searchReturnState = location => {
  if (!location?.pathname?.startsWith('/s')) return null;

  return {
    pathname: location.pathname,
    search: location.search || '',
    scrollY: typeof window === 'undefined' ? 0 : window.scrollY,
  };
};

export const getSearchReturn = location => {
  const stateValue = location?.state?.searchReturn;
  if (stateValue?.pathname?.startsWith('/s')) return stateValue;

  const encodedReturnTo = new URLSearchParams(location?.search || '').get('returnTo');
  if (!encodedReturnTo) return null;

  const [pathname, search = ''] = encodedReturnTo.split('?');
  return pathname?.startsWith('/s') ? { pathname, search: search ? `?${search}` : '', scrollY: null } : null;
};